import 'css-chunksrc/client/scenes/project/managerList/resource/styles.scss';export default {
  "resource": "_resource_1xind_1",
  "icon": "_icon_1xind_6",
  "removeTagIconContainer": "_removeTagIconContainer_1xind_14"
};